import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appLowercaseInput]'
})
export class LowercaseInputDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    console.log("Enter to directive")
    const lowercasedValue = inputElement.value.toLowerCase();

    // Only update if the value is different
    if (inputElement.value !== lowercasedValue) {
      inputElement.value = lowercasedValue;
      // Trigger Angular's two-way binding to update the model if necessary
      inputElement.dispatchEvent(new Event('input'));
    }
  }
}